import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { MY_PROPERTIES_LANDING_PAGE_PATH } from '@/router/routes/constants';
import { Pages } from '@/types';
import { RouteRecordRaw } from 'vue-router';

const routes: LocalizedRoutes = {
  de: { path: MY_PROPERTIES_LANDING_PAGE_PATH.de, meta: { requiresAuth: false } },
  en: { path: MY_PROPERTIES_LANDING_PAGE_PATH.en, meta: { requiresAuth: false } },
  fr: { path: MY_PROPERTIES_LANDING_PAGE_PATH.fr, meta: { requiresAuth: false } },
  it: { path: MY_PROPERTIES_LANDING_PAGE_PATH.it, meta: { requiresAuth: false } },
};

const Component = () => import('@/pages/MyPropertiesLandingPage/MyPropertiesLandingPage.vue');

const localizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(routes, Component, Pages.PropLanding);

export default localizedRouteConfig;
